import { formatPercentage } from '@/domain/common/format'
import { Percentage } from '@/domain/types/NumericValues'
import { testIds } from '@/ui/utils/testIds'
import { TransactionOverviewDetailsItem } from '../../common/components/transaction-overview/TransactionOverviewDetailsItem'
import { ArrowRightIcon } from 'lucide-react'

interface LTVChangeProps {
  currentMaxLTV: Percentage
  updatedMaxLTV?: Percentage
}

export function LTVChange({ currentMaxLTV, updatedMaxLTV }: LTVChangeProps) {
  if (!updatedMaxLTV) {
    return (
      <TransactionOverviewDetailsItem label="Maximum LTV">
        <div data-testid={testIds.dialog.eMode.transactionOverview.maxLtv.before}>
          {formatPercentage(currentMaxLTV)}
        </div>
      </TransactionOverviewDetailsItem>
    )
  }

  return (
    <TransactionOverviewDetailsItem label="Maximum LTV">
      <div className="flex flex-row items-center gap-2">
        <div data-testid={testIds.dialog.eMode.transactionOverview.maxLtv.before}>
          {formatPercentage(currentMaxLTV)}
        </div>
        <ArrowRightIcon className="h-5 w-5 text-muted-foreground" />
        <div data-testid={testIds.dialog.eMode.transactionOverview.maxLtv.after}>{formatPercentage(updatedMaxLTV)}</div>
      </div>
    </TransactionOverviewDetailsItem>
  )
}
